const scrollIntoView = (container, animatableItems, animationDelay = 0) => {
  let animationPlayedOnLoad = false;
  let previousY = 0;
  let previousRatio = 0;
  let animation = null;
  let animeImport = null;

  if (animatableItems) {
    animeImport = import(flu.chunks.anime).then(({ anime }) => {
      animation = anime({
        targets: animatableItems,
        opacity: {
          value: 1,
          duration: 750,
          delay: anime.stagger(200),
          easing: "easeInOutSine",
          delay: animationDelay,
        },
        autoplay: false,
      });
    });
  }

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
  };

  const observer = new IntersectionObserver(_onIntersection, observerOptions);

  observer.observe(container);

  function _onIntersection(entries) {
    entries.forEach(entry => {
      const currentY = entry.boundingClientRect.y;
      const currentRatio = entry.intersectionRatio;
      const isIntersecting = entry.isIntersecting;

      if (isIntersecting && !animationPlayedOnLoad) {
        animationPlayedOnLoad = true;
        _handleContainerInView();
      }

      if (currentY < previousY) {
        if (currentRatio > previousRatio && isIntersecting) {
          // Scrolling down and entering view
          _handleContainerInView();
        }
      } else if (currentY > previousY && !isIntersecting) {
        if (currentRatio < previousRatio) {
          // Scrolling up and leaving view
          container.classList.remove("in-view");
        }
      }

      previousY = currentY;
      previousRatio = currentRatio;
    });
  }

  function _handleContainerInView() {
    if (animeImport) {
      animeImport.then(() => {
        if (animation) {
          animation.play();
        }
      });
    }

    container.classList.add("in-view");

    observer.disconnect();
  }

  const unload = () => {
    observer.disconnect();
  };

  return { unload };
};

export default scrollIntoView;
